module.exports = __webpack_public_path__ + "static/img/failure.2ffb512f.png";